import { Text, Title } from "@clipboard-health/ui-components";
import { Button, CardActions, CardContent, Stack } from "@mui/material";
import { APP_V2_USER_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import { openInBrowser } from "@src/appV2/NativeAdapters/browser.adapter";
import { useSupportLinks } from "@src/appV2/support/hooks/useSupportLinks";

import { WorkplaceReferralAction, WorkplaceReferralComponent } from "../types";
import { WorkplaceReferralCard } from "./WorkplaceReferralCard/WorkplaceReferralCard";

interface ReferralGuideProps {
  referralCode?: string;
}

export function ReferralGuide(props: ReferralGuideProps) {
  const { referralCode } = props;
  const { affiliateGuideSupportLink } = useSupportLinks();

  const handleClick = async () => {
    logEvent(APP_V2_USER_EVENTS.WORKPLACE_REFERRAL, {
      action: WorkplaceReferralAction.REFERRAL_GUIDE_CLICKED,
      component: WorkplaceReferralComponent.REFERRAL_GUIDE_SECTION,
      referralCode,
    });
    // These are public articles are not behind the Zendesk SSO. (see useZendeskArticle Hook)
    await openInBrowser({ url: affiliateGuideSupportLink });
  };

  return (
    <WorkplaceReferralCard
      sx={(theme) => ({
        background: theme.palette.workplaceReferrals?.referralGuide.gradient,
        paddingY: 5,
      })}
    >
      <CardContent>
        <Stack spacing={2} alignItems="center">
          <Title bold component="h4">
            Affiliate Tips & Tricks
          </Title>
          <Text textAlign="center">
            Get additional tips for how to make successful referrals to workplaces
          </Text>
        </Stack>
      </CardContent>
      <CardActions>
        <Stack alignItems="center" width="100%">
          <Button variant="outlined" size="small" onClick={handleClick}>
            Access now
          </Button>
        </Stack>
      </CardActions>
    </WorkplaceReferralCard>
  );
}
